import type { ApplicantPortalOption } from '$constants/applicantPortalOption';

import type { OptionVisibilityState } from '$context/global-context/reducers/types';

/** Pure, never throws. Absent or empty config means shown (P1). */
export const isOptionVisible = (
  option: ApplicantPortalOption,
  visibility: OptionVisibilityState | undefined
): boolean => !visibility?.hiddenOptions?.includes(option);
